import { authHeader, handleResponse } from "../helpers";

export const faqService = {
  index,
  show,
  update,
  _delete,
  store,
  addSection,
  deleteSection,
  updateSection,
  addFaqSectionDetails,
  getSectionDetails,
  deleteSectionDetail,
  updateSectionDetail,
};

function index(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  console.log("params-----", params);

  let url = new URL(`${process.env.REACT_APP_API_URL}api/v1/section/list`);
  url.search = new URLSearchParams({
    type: params.type,
    user_type: params.user_type,
    keyword: params.keyword,
  });
  return fetch(url, requestOptions).then(handleResponse);
}

function show(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/faq/${id}`,
    requestOptions
  ).then(handleResponse);
}

function update(request, id) {
  let formBody = [];

  for (let property in request) {
    if (Array.isArray(request[property])) {
      for (let i = 0; i < request[property].length; i++) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(request[property][i]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
    } else {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(request[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
  }
  formBody = formBody.join("&");

  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader(),
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formBody,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/faq/${id}`,
    requestOptions
  ).then(handleResponse);
}

function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/faq/${id}`,
    requestOptions
  ).then(handleResponse);
}

function store(request) {
  let formBody = [];

  for (let property in request) {
    if (Array.isArray(request[property])) {
      for (let i = 0; i < request[property].length; i++) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(request[property][i]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
    } else {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(request[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
  }
  formBody = formBody.join("&");

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formBody,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/faq`,
    requestOptions
  ).then(handleResponse);
}

function addSection(request) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(request),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/add/section`,
    requestOptions
  ).then(handleResponse);
}

function deleteSection(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/section/${id}`,
    requestOptions
  ).then(handleResponse);
}

function updateSection(request) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(request),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/section/update`,
    requestOptions
  ).then(handleResponse);
}

function addFaqSectionDetails(request) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(request),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/add/section/detail`,
    requestOptions
  ).then(handleResponse);
}

function getSectionDetails(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/section/details/${id}`,
    requestOptions
  ).then(handleResponse);
}

function deleteSectionDetail(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/sectionContent/${id}`,
    requestOptions
  ).then(handleResponse);
}

function updateSectionDetail(request) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(request),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}api/v1/sectionContent/update`,
    requestOptions
  ).then(handleResponse);
}
